export class SubscriptionBuyingOpaque {
  subscriptionInfoId: number;
  isMonthly: boolean;
  promoCode?: string | null;
  currentUserId?: bigint;

  constructor(subscriptionInfoId: any, isMonthly: any, promoCode?: string | null, currentUserId?: bigint) {
    this.subscriptionInfoId = Number(subscriptionInfoId);
    this.isMonthly = Boolean(isMonthly);
    this.promoCode = promoCode;
    this.currentUserId = currentUserId;
  }
}
